import React from "react";
import ToastNotification from "./ToastNotification";

const NotificationContainer = ({ notifications, onRemoveNotification }) => {
  // Debug: log when notifications change
  React.useEffect(() => {
    if (notifications.length > 0) {
      console.log("Notifications active:", notifications.length);
    }
  }, [notifications]);

  return (
    <div
      className="fixed top-4 right-4 z-[9999] flex flex-col items-end pointer-events-none gap-3"
      style={{ maxWidth: "calc(100vw - 2rem)" }}
    >
      {notifications.map((notification) => (
        <div key={notification.id} className="pointer-events-auto">
          <ToastNotification
            notification={notification}
            onClose={() => onRemoveNotification(notification.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;

